import React from "react";
import { StldRadioOptions } from '../../styled-components/StyledRadioOptions.style';

export const DynamicRadio = ({ options }) => {
    return (
        <StldRadioOptions>
            {options.map((option, index) => {
                return (
                    <div key={index} className="mr-2">
                        <input type="radio" value={option.value} name={option.name} className="mr-2" />
                        {option.label}
                    </div>
                )
            })}
        </StldRadioOptions>
    )
}